export const matters_CreateContent = [
	{
		icon: '🔹',
		title: 'mattersData.title1',
		subtitle: 'mattersData.subtitle1',
	},
	{
		icon: '🔹',
		title: 'mattersData.title2',
		subtitle: 'mattersData.subtitle2',
	},
	{
		icon: '🔹',
		title: 'mattersData.title3',
		subtitle: 'mattersData.subtitle3',
	},
	{
		icon: '🔹',
		title: 'mattersData.title4',
		subtitle: 'mattersData.subtitle4',
	},
];

export const mattersAboveList = [
	{
		text: 'mattersData.textAbove.text1',
	},
];
